import React, { ReactElement } from "react"

export const SvgOptions = (): ReactElement => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    style={{ backgroundColor: "transparent", flexShrink: 0 }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 0C3.36433 0 0 3.36433 0 7.5C0 11.6357 3.36433 15 7.5 15C11.6357 15 15 11.6357 15 7.5C15 3.36433 11.6357 0 7.5 0ZM10.7812 8.12496H8.12496V10.7812C8.12496 11.1263 7.84504 11.4062 7.5 11.4062C7.15496 11.4062 6.87504 11.1263 6.87504 10.7812V8.12496H4.21875C3.87371 8.12496 3.59379 7.84504 3.59379 7.5C3.59379 7.15496 3.87371 6.87504 4.21875 6.87504H6.87504V4.21875C6.87504 3.87371 7.15496 3.59379 7.5 3.59379C7.84504 3.59379 8.12496 3.87371 8.12496 4.21875V6.87504H10.7812C11.1263 6.87504 11.4062 7.15496 11.4062 7.5C11.4062 7.84504 11.1263 8.12496 10.7812 8.12496Z"
      fill="#308FFF"
    />
  </svg>
)
